<template>
  <div class="fgarticont">
    <div class="zwtitle">劳动者不与用人单位签定书面劳动合同的后果</div>
    <div class="fgnrlist" ref="fgnrlist">
      <div class="fgnritem">
        <div class="nritemtit"><span>导读</span></div>
        <div class="nr" v-html="articdata.daod"></div>
      </div>

      <div class="fgnritem">
        <div class="nritemtit"><span>概括描述</span></div>
        <div class="nr" v-html="articdata.gainjd"></div>
      </div>

      <div class="fgnritem">
        <div class="nritemtit"><span>参考案例</span></div>
        <div class="nr" v-html="articdata.cankal"></div>
      </div>

      <div class="fgnritem">
        <div class="nritemtit"><span>法律依据</span></div>
        <div class="nr" v-html="articdata.falyj"></div>
      </div>

      <div class="fgnritem">
        <div class="nritemtit"><span>解决办法</span></div>
        <div class="nr" v-html="articdata.jiejff"></div>
      </div>

      <div class="fgnritem">
        <div class="nritemtit"><span>法律攻略</span></div>
        <!-- <div class="gytag flex_start">
          <div
            class="gytagitem"
            :class="{ actv: gytagactc == 0 }"
            @click="gytagchange(0)"
          >
            调解<i class="actvicon el-icon-caret-bottom"></i>
          </div>
          <div
            class="gytagitem"
            :class="{ actv: gytagactc == 1 }"
            @click="gytagchange(1)"
          >
            仲裁<i class="actvicon el-icon-caret-bottom"></i>
          </div>
          <div
            class="gytagitem"
            :class="{ actv: gytagactc == 2 }"
            @click="gytagchange(2)"
          >
            诉讼<i class="actvicon el-icon-caret-bottom"></i>
          </div>
        </div> -->
        <div class="gytagcont" v-html="articdata.falgl"></div>
      </div>

      <div class="fgnritem">
        <div class="nritemtit"><span>推荐律师</span></div>
        <div class="between">
          <homelaywin
            class="mt30 tjlawitem text_center"
            v-for="item in 3"
            :key="item"
            :consultOrMore="true"
            :isBorder="false"
          />
        </div>
      </div>
    </div>
    <articaside
      v-show="ishide"
      ref="articaside"
	  :ismu="true"
      :style="{ bottom: asidebom }"
      :nodedata="nodedata"
      refname="fgnrlist"
    />
  </div>
</template>

<script>
import homelaywin from "views/home/components/layItemWin";
import articaside from "../components/articaside";

export default {
  props: {
    hidetop: Number,
  },
  components: {
    homelaywin,
    articaside,
  },
  data: () => ({
    ishide: false,
    articdata: {},
    gytagactc: 0,
    asidebom: "50px",
    nodedata: [
      {
        name: "导读",
        ywname: "takeaway",
      },
      {
        name: "概括描述",
        ywname: "takeaway",
      },
      {
        name: "参考案例",
        ywname: "takeaway",
      },
      {
        name: "法律依据",
        ywname: "takeaway",
      },
      {
        name: "解决办法",
        ywname: "takeaway",
      },
      // {
      //   name:'温馨提醒',
      //   ywname:'takeaway'
      // },
      {
        name: "法律攻略",
        ywname: "takeaway",
      },
      {
        name: "推荐律师",
        ywname: "takeaway",
      },
    ],
  }),
  beforeMount() {
    this.getfaart();
  },
  mounted() {
    // 监听滚动事件
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    // 移除滚动监听
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      let bomjl = window.pageYOffset + window.innerHeight; //获取x点坐标加上窗口左边，得到底部滚动距离
      let bomofftop = document.querySelector(".footer").offsetTop; //获取footer的offsetTop值
      this.ishide = bomjl > this.hidetop + 650;
      if (bomjl > bomofftop) {
        this.asidebom = bomjl - bomofftop + 50 + "px";
      } else {
        this.asidebom = "50px";
      }
    },
    gytagchange(index) {
      this.gytagactc = index;
    },
    getfaart() {
      let data = {
        id: this.$route.query.faId,
      };
      this.$http.jpcol
        .getsolutioncontent(data)
        .then((res) => {
          this.articdata = res.data;
        })
        .catch((err) => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.fgarticont {
  width: 100%;
  padding: 34px 53px;
  .zwtitle {
    font-size: 28px;
    color: #333333;
    line-height: 28px;
  }
  .fgnrlist {
    .fgnritem {
      margin-top: 30px;
      .nritemtit {
        border-bottom: 1px solid #eee;
        font-size: 24px;
        color: #333333;
        line-height: 24px;
        padding-bottom: 10px;
        span {
          padding-bottom: 6px;
          border-bottom: 3px solid #0465ea;
        }
      }
      .nr {
        line-height: 32px;
        text-indent: 2em;
        margin-top: 26px;
      }
      .gytag {
        margin-top: 30px;
        .gytagitem {
          cursor: pointer;
          margin-right: 22px;
          width: 148px;
          height: 44px;
          text-align: center;
          line-height: 44px;
          background: #eef5ff;
          font-size: 18px;
          color: #333333;
          position: relative;
          .actvicon {
            display: none;
            color: #0465ea;
            position: absolute;
            font-size: 40px;
            bottom: -25px;
            left: 50%;
            transform: translateX(-50%);
          }
          &.actv {
            color: #fff;
            background-color: #0465ea;
            .actvicon {
              display: block;
            }
          }
        }
      }
      .gytagcont {
        margin-top: 40px;
        width: 100%;
        padding: 25px 16px;
        background: #f9f9f9;
        font-size: 14px;
        color: #333333;
        line-height: 28px;
      }

      .tjlawitem {
        width: 223px;
        height: 314px;
      }
    }
  }
}
</style>